var r = Array.isArray, a = r;
export {
  a as default
};
//# sourceMappingURL=isArray.js.map
